
import React from "react";
import { GlassCard } from "@/components/ui/glass-card";
import { BrandLogo } from "../layout/nav/brand-logo";

interface BaseFormProps {
  title: string;
  children: React.ReactNode;
}

export function BaseForm({ title, children }: BaseFormProps) {
  return (
    <div className="w-full max-w-md mx-auto animate-fade-in">
      <GlassCard className="p-8">
        <div className="flex justify-center mb-6">
          <BrandLogo size="large" />
        </div>
        
        <h2 className="text-2xl font-bold text-center mb-6">{title}</h2>
        
        {children}
      </GlassCard>
    </div>
  );
}
